// extracted by mini-css-extract-plugin
export default {"fold":"prepaiCTA_fold__ZLZBT","textContainer":"prepaiCTA_textContainer__6zRlk","openBtn":"prepaiCTA_openBtn__hGqfb","copyBtn":"prepaiCTA_copyBtn__5ec6r"};